module.exports = __webpack_public_path__ + "img/1308222298.1f0b1633.jpg";